import { useContent } from "../context/SiteContentContext";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";


export default function FAQPage() {
  const { get } = useContent();
  const FAQS = get("faq.items");
  return (
    <div className="pt-32 pb-24 grain min-h-screen" data-testid="faq-page">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="eyebrow">Questions, Answered</div>
          <h1 className="font-display text-5xl sm:text-6xl mt-6">FAQ</h1>
          <div className="divider-gold mx-auto" />
        </div>
        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="glass border border-white/5 px-6"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-white text-left hover:no-underline py-6 font-display text-lg">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-luxury-body pb-6">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
